function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.277 15.69C3.774 12.021 2 9.182 2 7a6 6 0 1112 0c0 2.182-1.774 5.021-5.277 8.69a1 1 0 01-1.446 0zM10 7a2 2 0 11-4 0 2 2 0 014 0z"
});

function SvgMapMarker16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjI3NjYxIDE1LjY5MDRDMy43NzQ0OSAxMi4wMjEyIDIgOS4xODIwMyAyIDdDMiAzLjY4NjI5IDQuNjg2MjkgMSA4IDFDMTEuMzEzNyAxIDE0IDMuNjg2MjkgMTQgN0MxNCA5LjE4MjAzIDEyLjIyNTUgMTIuMDIxMiA4LjcyMzM5IDE1LjY5MDRDOC4zMjk0NCAxNi4xMDMyIDcuNjcwNTYgMTYuMTAzMiA3LjI3NjYxIDE1LjY5MDRaTTEwIDdDMTAgOC4xMDQ1NyA5LjEwNDU3IDkgOCA5QzYuODk1NDMgOSA2IDguMTA0NTcgNiA3QzYgNS44OTU0MyA2Ljg5NTQzIDUgOCA1QzkuMTA0NTcgNSAxMCA1Ljg5NTQzIDEwIDdaIi8+Cjwvc3ZnPgo=";
export { SvgMapMarker16 as ReactComponent };